import React from "react";
import { useState, useEffect } from "react";
import { Box, Button, Typography, TextField, Autocomplete } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as yup from "yup";
import FormikErrorText from "../components/FormikErrorText";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { colors } from "../theme/Colors";

//imgs
import background from "../../src/imgs/squidlarge.png";
import squidTitle from "../../src/imgs/squidGameTitle.svg";
import fantasiaLand from "../../src/imgs/fantasialand.svg";
import x from "../../src/imgs/X.svg";
import gagency from "../../src/imgs/gagency.png";
import fb from "../../src/imgs/fb.svg";
import insta from "../../src/imgs/insta.svg";
import Ticker from "../components/Ticker";
import essania from "../../src/imgs/essania_white.svg";

//firestore
import db from "../firebase/firebase";
import { collection, addDoc, query, where, getDocs, onSnapshot } from "firebase/firestore";

//success
import Success from "./Success";

function ClosedSignup() {
  // const [selectedWilaya, setSelectedWilaya] = useState();
  // const [searchedWilaya, setSearchedWilaya] = useState();

  const [countParticipants, setCountParticipants] = useState();
  const [loading, setLoading] = useState(false);
  const [didSubmit, setDidSubmit] = useState(false);

  //wilayas
  const wilayas = [
    { id: "1", name: "Adrar" },
    { id: "2", name: "Chlef" },
    { id: "3", name: "Laghouat" },
    { id: "4", name: "Oum El Bouaghi" },
    { id: "5", name: "Batna" },
    { id: "6", name: "Béjaïa" },
    { id: "7", name: "Biskra" },
    { id: "8", name: "Bechar" },
    { id: "9", name: "Blida" },
    { id: "10", name: "Bouira" },
    { id: "11", name: "Tamanrasset" },
    { id: "12", name: "Tbessa" },
    { id: "13", name: "Tlemcen" },
    { id: "14", name: "Tiaret" },
    { id: "15", name: "Tizi Ouzou" },
    { id: "16", name: "Alger" },
    { id: "17", name: "Djelfa" },
    { id: "18", name: "Jijel" },
    { id: "19", name: "Se9tif" },
    { id: "20", name: "Saefda" },
    { id: "21", name: "Skikda" },
    { id: "22", name: "Sidi Bel Abbes" },
    { id: "23", name: "Annaba" },
    { id: "24", name: "Guelma" },
    { id: "25", name: "Constantine" },
    { id: "26", name: "Medea" },
    { id: "27", name: "Mostaganem" },
    { id: "28", name: "M'Sila" },
    { id: "29", name: "Mascara" },
    { id: "30", name: "Ouargla" },
    { id: "31", name: "Oran" },
    { id: "32", name: "El Bayadh" },
    { id: "33", name: "Illizi" },
    { id: "34", name: "Bordj Bou Arreridj" },
    { id: "35", name: "Boumerdes" },
    { id: "36", name: "El Tarf" },
    { id: "37", name: "Tindouf" },
    { id: "38", name: "Tissemsilt" },
    { id: "39", name: "El Oued" },
    { id: "40", name: "Khenchela" },
    { id: "41", name: "Souk Ahras" },
    { id: "42", name: "Tipaza" },
    { id: "43", name: "Mila" },
    { id: "44", name: "Ain Defla" },
    { id: "45", name: "Naama" },
    { id: "46", name: "Ain Temouchent" },
    { id: "47", name: "Ghardaefa" },
    { id: "48", name: "Relizane" },
    { id: "49", name: "El M'ghair" },
    { id: "50", name: "El Menia" },
    { id: "51", name: "Ouled Djellal" },
    { id: "52", name: "Bordj Baji Mokhtar" },
    { id: "53", name: "Béni Abbès" },
    { id: "54", name: "Timimoun" },
    { id: "55", name: "Touggourt" },
    { id: "56", name: "Djanet" },
    { id: "57", name: "In Salah" },
    { id: "58", name: "In Guezzam" },
  ];

  //initial values
  const initialValues = {
    lastName: "",
    firstName: "",
    wilaya: null,
    email: "",
    phone: "",
  };

  //validation schema
  const validationSchema = yup.object({
    lastName: yup.string().required("Ce champ est obligatoire"),
    firstName: yup.string().required("Ce champ est obligatoire"),
    wilaya: yup.object().required("Ce champ est obligatoire"),
    email: yup.string().required("Ce champ est obligatoire"),
    phone: yup
      .string()
      .matches(/^\d{10}$/, "Numéro de téléphone invalide")
      .required("Ce champ est obligatoire"),
  });

  //count number of users

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "Participants"), (snapshot) => {
      setCountParticipants(snapshot?.docs?.length);
    });

    return unsub;
  }, []);

  //add new user
  const onSubmit = async (values) => {
    setLoading(true);
    const collectionRef = collection(db, "Participants");

    await addDoc(collectionRef, values);
    toast.success("Vos informations sont enregistrées", {
      fontSize: "16px",
      position: "top-right",
      autoClose: 15000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: 0,
      progressStyle: { background: colors.main },
      theme: "colored",
      style: { background: "black" },
    });

    setLoading(false);
  };

  return (
    <Box position="relative" sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", overflow: "hidden" }}>
      <img style={{ width: "100%", height: "100%", objectFit: "cover" }} src={background} alt="squidgame" />
      <Box sx={{ display: "flex", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", backgroundColor: "rgba(142, 142, 142, 0.1)", backdropFilter: "blur(15px)" }} maxWidth="450px" minWidth="350px" padding="16px" borderRadius={"16px"}>
        <Box display="flex" alignItems="center" justifyContent="center" gap="24px" flexDirection="column" width="100%" padding="16px">
          <img style={{ width: "100px" }} src={squidTitle} alt="squidgame-title" />
          {/* <img style={{ width: "30px" }} src={x} alt="x" />
          <img style={{ width: "260px" }} src={essania} alt="essania" /> */}

          <Box textAlign="center" padding="8px" display="flex" gap="16px" flexDirection="column" color="white">
            <Typography fontSize="18px">Les inscriptions sont clôturées, merci à tous pour votre participation et pour ceux qui n'ont pas pu participer, vous pourrez vous inscrire bientôt à la prochaine session, restez accrochés ! </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ display: "flex", position: "absolute", top: "95%", left: "50%", transform: "translate(-50%, -50%)" }} borderRadius={"16px"}>
        <Box display="flex" alignItems="center" justifyContent="center" gap="24px" flexDirection="row" width="100%">
          <Box sx={{ cursor: "pointer" }} onClick={() => window.open("https://web.facebook.com/G.AGENCY.DZ", "_blank")}>
            <img style={{ width: "25px" }} src={fb} alt="facebook" />
          </Box>
          <Box sx={{ cursor: "pointer" }} onClick={() => window.open("https://www.instagram.com/squid_game_algerie", "_blank")}>
            <img style={{ width: "25px" }} src={insta} alt="instagram" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default ClosedSignup;
